"use client";

import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface SetupPillProps {
  percent: number;       // 0–100
  onOpen: () => void;    // callback to reopen wizard
  className?: string;
}

export function SetupPill({ percent, onOpen, className }: SetupPillProps) {
  const { t } = useTranslation("common");

  // Hide when not started (0%) or fully complete (100%)
  if (percent <= 0 || percent >= 100) return null;

  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        "flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium leading-none transition-colors",
        "bg-amber-50 border-amber-200 text-amber-800",
        "dark:bg-amber-950 dark:border-amber-800 dark:text-amber-400",
        "hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className
      )}
    >
      <span>⚙</span>
      <span>
        {t("setup")}{" "}
        <span className="tabular-nums">{percent}%</span>
      </span>
    </button>
  );
}
